<app-data-table mainTitle="Comissão Base"
                singleTitle="Comissão Base"
                routerPath="/comissao-base"
                entityPath="/comissaobase"
                [entity]="comissaoBase"
                [entityFilter]="entityFilter"
                [columns]="this['columns']"
                [controls]="this['controls']">
</app-data-table>
